import { createReducer, on } from '@ngrx/store';
import * as ReviewEntriesActions from './../actions/review-entries.actions';

export interface State {
  groups: any[];
  groupsSupervisorNumber: number | null;
  departments: any[];
  pendingRecords: any[];
  counts: any[];
  calendarInfo: any | null;
  calendarInfoKey: string | null;
  supervisorHeadEmpDetails: any[];
  headDetails: any[];
  lastLoadedParams: any | null;
  loading: boolean;
  error: any;
}

export const initialState: State = {
  groups: [],
  groupsSupervisorNumber: null,
  departments: [],
  pendingRecords: [],
  counts: [],
  calendarInfo: null,
  calendarInfoKey: null,
  supervisorHeadEmpDetails: [],
  headDetails: [],
  lastLoadedParams: null, // Initialize to null
  loading: false,
  error: null,
};

export const reviewEntriesReducer = createReducer(
  initialState,
  // Groups
  on(ReviewEntriesActions.loadGroups, (state) => ({ ...state, loading: true })),
  on(ReviewEntriesActions.loadGroupsSuccess, (state, { groups, supervisorNumber }) => ({
    ...state,
    loading: false,
    groups,
    groupsSupervisorNumber: supervisorNumber,
  })),
  on(ReviewEntriesActions.loadGroupsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Departments
  on(ReviewEntriesActions.loadDepartments, (state) => ({
    ...state,
    loading: true,
  })),
  on(ReviewEntriesActions.loadDepartmentsSuccess, (state, { departments }) => ({
    ...state,
    loading: false,
    departments,
  })),
  on(ReviewEntriesActions.loadDepartmentsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Pending Records
  on(ReviewEntriesActions.loadPendingRecordsSuccess, (state, { pendingRecords }) => ({
    ...state,
    pendingRecords,
    loading: false,
  })),
  on(ReviewEntriesActions.loadPendingRecordsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Calendar Count
  on(ReviewEntriesActions.loadCalendarCounts, (state) => ({
    ...state,
    loading: true,
  })),
  on(ReviewEntriesActions.loadCalendarCountsSuccess, (state, { counts }) => ({
    ...state,
    counts, // Update calendar count in the state
    loading: false,
  })),
  on(ReviewEntriesActions.loadCalendarCountsFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
  // Calendar Info
  on(ReviewEntriesActions.loadCalendarInfo, (state) => ({
    ...state,
    loading: true,
  })),
  on(ReviewEntriesActions.loadCalendarInfoSuccess, (state, { calendarInfo, employeeNumber, calendarDate }) => ({
    ...state,
    calendarInfo,
    calendarInfoKey: `${employeeNumber}|${calendarDate}`,
    loading: false,
  })),
  on(ReviewEntriesActions.loadCalendarInfoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ReviewEntriesActions.clearCalendarInfo, (state) => ({
    ...state,
    calendarInfo: null,
    calendarInfoKey: null,
  })),

  // Supervisor Head Emp Details
  on(ReviewEntriesActions.loadSupervisorHeadEmpDetails, (state) => ({ ...state, loading: true })),
  on(ReviewEntriesActions.loadSupervisorHeadEmpDetailsSuccess, (state, { supervisorHeadEmpDetails }) => ({
    ...state,
    loading: false,
    supervisorHeadEmpDetails,
  })),
  on(ReviewEntriesActions.loadSupervisorHeadEmpDetailsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Page Supervisor Head Details
  on(ReviewEntriesActions.loadPageSupervisorHeadDetails, (state, { ...params }) => ({
    ...state,
    loading: true,
    error: null,
    lastLoadedParams: params, // Save the parameters triggering the API call
  })),
  on(ReviewEntriesActions.loadPageSupervisorHeadDetailsSuccess, (state, { headDetails }) => ({
    ...state,
    headDetails: headDetails,
    loading: false,
  })),
  on(ReviewEntriesActions.loadPageSupervisorHeadDetailsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))

);
